
import { Component, Vue, Prop } from 'vue-property-decorator'
import { getGoodsInfo, GoodsInfoDto, editGoodsSubmit } from '@/api/commodity'
import { LevelListDto, getMerchantsLevelList } from '@/api/customerManage'
import { customerLevelDto } from '@/api/goods'
import { formatterMoney, printFn } from '@/utils/util'
// @ts-ignore
import { isEmpty } from 'lodash'

@Component
export default class coomdsPrice extends Vue {
  @Prop({ default: 0 }) marketPrice?: number
  formatterMoney = formatterMoney
  goodsInfo: GoodsInfoDto | Record<string, any> = {}
  levelList: LevelListDto[] | customerLevelDto[] = []
  showLevelPicker = false
  visible = false
  cusLevelPriceList = []
  type = ''

  get $isDetail() {
    return this.type === 'detail'
  }

  created() {}

  handleChangeCustomerLevel(data: LevelListDto | customerLevelDto) {
    this.goodsInfo = data
  }

  showModal(res: {
    data: customerLevelDto[]
    marketPrice: number
    type: string
  }) {
    this.type = res.type
    this.visible = true
    if (!res.data.length) {
      this.getLevelList().then(() => {
        this.handleChangeCustomerLevel(this.levelList[0])
        this.initOrderPrice(res.marketPrice)
      })
    } else {
      this.levelList = res.data
      // 每一个默认限定量都为9999
      this.levelList.forEach((item, index) => {
        if(!item.maximum){
          this.$set(this.levelList[index], 'maximum', 9999)
        }
      })
      this.handleChangeCustomerLevel(this.levelList[0])
    }
    if (this.$route.name === 'CommodsDetail') {
      this.$eventBus.$emit('currentPage', 6)
    }
  }

  handleBack() {
    this.$eventBus.$emit('currentPage', 5)
    this.visible = false
  }

  handleHomeBack () {
    if(this.$isDetail){
      this.$goHomeBack()
      return false
    }
    this.$confirmDialog.show({
      okText: '确认',
      cancelText: '取消',
      tips: '现在退出则不会保存已修改内容，是否确认退出?',
      onOk: () => {
        this.$goHomeBack()
      },
    })
  }

  initOrderPrice(marketPrice: number) {
    this.levelList.forEach((item, index: number) => {
      const orderPrice = printFn(
        (Number(marketPrice || 0) * Number(item.buyDiscount || 0)) / 100
      )
      this.$set(this.levelList![index], 'orderPrice', orderPrice)
    })
  }

  handleMaximumBlur(data: customerLevelDto) {
    if (Number(data.maximum) === 0 && !isEmpty(data.maximum)) {
      data.maximum = 1
    }
    if (data.maximum > this.$defaultSettings.maxNumber(8)) {
      data.maximum = this.$defaultSettings.maxNumber(8)
    }
  }

  /**
   * 获取客户级别列表
   */
  getLevelList() {
    return new Promise((resolve) => {
      getMerchantsLevelList().then((res) => {
        this.levelList = res.data.levelList || []
        this.levelList.forEach((item, index: number) => {
          this.$set(this.levelList[index], 'orderPrice', 0)
          this.$set(this.levelList[index], 'minimum', 1)
          this.$set(this.levelList[index], 'maximum', 9999)
          console.log('this.levelList[index]', this.levelList[index])

          item.customerLevelId = item.customerLevelId || item.levelId
        })
        resolve(true)
      })
    })
  }

  levelConfirm(value: LevelListDto, index: number) {
    this.showLevelPicker = false
    this.handleChangeCustomerLevel(this.levelList[index])
  }

  validatEmptyOrderPrice() {
    return new Promise((resolve) => {
      let emptyOrderPrice = this.levelList.some((priceForm) => {
        return (
          Number(priceForm.minimum) > Number(priceForm.maximum) &&
          priceForm.maximum
        )
      })
      if (emptyOrderPrice) {
        this.$toast('起订量不能大于限订量')
      } else {
        resolve(true)
      }
    })
  }

  addSure() {
    this.validatEmptyOrderPrice().then((res) => {
      this.$emit('on-save', this.levelList)
      this.handleBack()
    })
  }
}
